// One badge for every status in the app - text + colour, never colour alone.
import React from 'react';
import {
  CHOREOGRAPHY_STATUS,
  COMPETITION_STATUS,
  PAYMENT_STATUS,
  INVOICE_STATUS,
  VERIFICATION_STATUS,
} from '../../constants/categories';

const MAPS = {
  choreography: CHOREOGRAPHY_STATUS,
  competition: COMPETITION_STATUS,
  payment: PAYMENT_STATUS,
  invoice: INVOICE_STATUS,
  verification: VERIFICATION_STATUS,
};

const TONE_CLASSES = {
  green: 'bg-green-100 text-green-800',
  amber: 'bg-amber-100 text-amber-800',
  red: 'bg-red-100 text-red-800',
  blue: 'bg-blue-100 text-blue-800',
  purple: 'bg-purple-100 text-purple-800',
  gray: 'bg-gray-100 text-gray-700',
  slate: 'bg-slate-200 text-slate-700',
};

export default function StatusBadge({ kind = 'choreography', status, className = '', showHint = false }) {
  const meta = (MAPS[kind] || {})[status];
  if (!meta && !status) return null;
  const label = meta?.label || status;
  const tone = TONE_CLASSES[meta?.tone] || TONE_CLASSES.gray;
  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${tone} ${className}`}
      title={meta?.hint || undefined}
    >
      {label}
      {showHint && meta?.hint && <span className="sr-only">. {meta.hint}</span>}
    </span>
  );
}
